import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { ToastToDisplay, ToastsState, ToastDisplayed } from './state';
import { toastsSliceName } from './constants';

const toastsSlice = createSlice({
  name: toastsSliceName,
  initialState: ToastsState,
  reducers: {
    showToast: (state, action: PayloadAction<ToastToDisplay>) => {
      const toast = action.payload;
      // Prevent duplicate toasts with same uniqueId
      if (toast.uniqueId !== undefined && state.toasts.some((t) => !t.isDismissed && t.uniqueId === toast.uniqueId)) {
        return;
      }
      const newToast: ToastDisplayed = {
        id: uuidv4(),
        createdAt: Date.now(),
        isDismissed: false,
        autoHide: toast.autoHide ?? true,
        ...toast,
      };
      state.toasts.unshift(newToast);
    },
    closeToast: (state, action: PayloadAction<{ toastId: string }>) => {
      const toast = state.toasts.find((t) => t.id === action.payload.toastId);
      if (toast !== undefined) {
        toast.isDismissed = true;
      }
    },
    removeToast: (state, action: PayloadAction<{ toastId: string }>) => {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload.toastId);
    },
    resetToastsState: () => ToastsState,
  },
});

const { actions, reducer } = toastsSlice;
export { reducer as toastsReducer };
export const { showToast, closeToast, removeToast, resetToastsState } = actions;
